// extracted by mini-css-extract-plugin
export default {"container":"KO-z","title":"LO-z","link":"MO-z"};